import React from 'react';
import './LegalPage.css';

function PrivacyPolicyPage() {
  const lastUpdated = '22-04-2026';
  const isPopup = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('popup') === '1';

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        {!isPopup && (
          <a href="/" className="legal-page__close" aria-label="Close and return to avatar experience">
            X
          </a>
        )}
        <h1 className="legal-page__title">Privacy Policy</h1>
        <p className="legal-page__intro">
          Please review how we collect, use, and protect your information.
        </p>

        <section className="legal-page__section">
          <p>
            <strong>Last Updated:</strong> {lastUpdated}
          </p>

          <h2>1. Information We Collect</h2>
          <p>
            Since our service relies on minimal user inputs (&quot;Speak&quot; and &quot;Mute&quot;),
            our data collection is highly specific:
          </p>
          <ul>
            <li>
              <strong>Voice &amp; Audio Data:</strong> When you use the &quot;Speak&quot; function,
              we temporarily capture audio from your device&apos;s microphone.
            </li>
            <li>
              <strong>Transcripts:</strong> We collect the text transcript converted from your
              speech to generate the AI&apos;s response.
            </li>
            <li>
              <strong>Usage Data:</strong> We log actions such as when you press &quot;Mute&quot; or
              &quot;Speak&quot; to ensure the app functions correctly (e.g., stopping audio playback
              when requested).
            </li>
            <li>
              <strong>Technical Data:</strong> IP address and browser type to manage API
              connections and security.
            </li>
          </ul>

          <h2>2. How We Use Your Data</h2>
          <ul>
            <li>
              <strong>Real-Time Processing:</strong> Your voice is sent to a Speech-to-Text (STT)
              provider solely to convert your spoken words into a text prompt for the Edward Berwind AI.
            </li>
            <li>
              <strong>Conversation History:</strong> We use the text transcripts to maintain the
              context of your conversation.
            </li>
            <li>
              <strong>Service Improvement:</strong> Anonymized text transcripts may be used to
              improve the historical accuracy of the AI model.
            </li>
          </ul>

          <h2>3. Third-Party AI &amp; Voice Processors</h2>
          <p>
            We do not process your voice locally on your device; it is transmitted to secure
            third-party cloud providers. By using this service, you acknowledge and agree that your
            data will be processed by:
          </p>
          <ul>
            <li>
              <strong>OpenAI / ElevenLabs/ HeyGen / Google / AWS:</strong> Used for Large Language
              Model (LLM) generation and Speech-to-Text (STT) / Text-to-Speech (TTS) conversion.
            </li>
          </ul>
          <p>
            <strong>Note:</strong> These providers are prohibited from using your data to train
            their own models in a way that identifies you, but they may retain logs for abuse
            monitoring (typically 30 days).
          </p>

          <h2>4. Data Retention</h2>
          <ul>
            <li>
              <strong>Audio Files:</strong> We do not permanently store your raw audio recordings.
              Once the audio is converted to text, the raw voice file is discarded from our active
              servers.
            </li>
            <li>
              <strong>Text Transcripts:</strong> Anonymized text transcripts of your conversation
              may be retained for 30 days for quality assurance and then deleted.
            </li>
          </ul>

          <h2>5. User Rights &amp; Controls</h2>
          <ul>
            <li>
              <strong>Mute Function:</strong> Pressing &quot;Mute&quot; stops the audio output
              immediately. It does not delete the text history of the conversation.
            </li>
            <li>
              <strong>Microphone Access:</strong> You can revoke microphone permissions at any time
              via your browser or device settings. This will disable the &quot;Speak&quot; feature
              but allow you to view past text (if applicable).
            </li>
          </ul>

          <h2>6. Children&apos;s Privacy</h2>
          <p>
            This service is not intended for children under the age of 13. We do not knowingly
            collect voice data from children. If we discover such data has been collected, it will
            be deleted immediately.
          </p>

          <h2>7. Contact Us</h2>
          <p>
            For privacy concerns regarding your voice data, please contact:{' '}
            <strong>support@actiontourguide.com</strong>
          </p>
        </section>

        <div className="legal-page__actions">
          <a href={isPopup ? '/terms-of-service?popup=1' : '/terms-of-service'} className="legal-page__link legal-page__link--secondary">
            View Terms of Service
          </a>
          {!isPopup && (
            <a href="/" className="legal-page__link">
              Back to Avatar Experience
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;

